import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";
import { replaceUnderscoresWithSpaces } from "utils";
import { fetchFranchiseDropdownDD } from "services/dropdown";
import { useSelector } from "react-redux";

const PanelDropDown = ({
  setFilterValue,
  showSuperFranchise,
  zoneIdPayload = true,
  zoneId,
  fromFranchise = false,
  toFranchise = false,
  selectedValue,
}) => {
  const key = "panel";
  const isSuperFranchise = localStorage.getItem("is_super_franchise");
  const login = useSelector((state) => state.jwtAuthreducer);

  const finalZoneId =
    zoneId ??
    (zoneIdPayload ? Number(localStorage.getItem("zone_id")) : undefined);

  const { data, isLoading, refetch, error } = useQuery(
    ["panel-dropdown", finalZoneId],
    () =>
      fetchFranchiseDropdownDD({
        ...login,
        ...(finalZoneId && { zone_id: finalZoneId }),
      }),
    {
      keepPreviousData: false,
      staleTime: DROPDOWN_STALE_TIME,
    }
  );

  useEffect(() => {
    refetch();
  }, [login, finalZoneId]);

  const options = useMemo(() => {
    if (!data?.data?.data) return [];

    if (showSuperFranchise) {
      return data.data.data
        .filter(
          (item) => !(isSuperFranchise === "1" && item.is_super_franchise)
        )
        .map((item) => ({
          value: item.id,
          label: `${item.franchise_code}, ${item.company_name}`,
        }));
    } else {
      return data.data.data.map((item) => ({
        value: item.id,
        label: `${item.franchise_code}, ${item.company_name}`,
      }));
    }
  }, [data, showSuperFranchise, isSuperFranchise]);

  const selectedOption = useMemo(() => {
    if (!selectedValue) return null;
    return options.find((option) => option.value === selectedValue) || null;
  }, [selectedValue, options]);

  useEffect(() => {
    if (options.length === 1 && !selectedValue) {
      const value = options[0].value;

      if (fromFranchise) {
        setFilterValue("from_franchise_id", value);
      } else if (toFranchise) {
        setFilterValue("to_franchise_id", value);
      } else {
        setFilterValue("franchise_id", value);
      }
    }
  }, [options, selectedValue, fromFranchise, toFranchise, setFilterValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading franchise type</div>;

  return (
    <Select
      options={options}
      value={selectedOption}
      isClearable
      placeholder={`Select ${replaceUnderscoresWithSpaces(key)}`}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      onChange={(selectedOption) => {
        const value = selectedOption ? selectedOption.value : "";

        if (fromFranchise) {
          setFilterValue("from_franchise_id", value);
        } else if (toFranchise) {
          setFilterValue("to_franchise_id", value);
        } else {
          setFilterValue("franchise_id", value);
        }
      }}
      className="react-select-container is-invalid"
    />
  );
};

export default PanelDropDown;
